import { ConfigItem } from 'Core/interfaces'

export enum ScaleSearchResultFields {
	id = 'id',
	name = 'name'
}

export enum ScaleFilterFields {
	includeInactive = 'includeInactive',
	name = 'name',
	id = 'id'
}

export enum ScaleLabels {
	ScaleId = 'id',
	ScaleName = 'name',
	ScaleType = 'type',
	OrderingQuestion = 'orderingQuestion',
	AskCustomer = 'askCustomer',
	Active = 'isActive'
}

export enum ItemPriceErrorLabels {
	Id = 'id',
	ScaleId = 'scaleId',
	ItemId = 'itemId',
	ItemName = 'itemName'
}

export enum ScalePriceLabels {
	ScalePriceId = 'id',
	ScalePriceName = 'name',
	LowValue = 'lowValue',
	HighValue = 'highValue',
	Unit = 'unit',
	Default = 'isDefault'
}
export declare namespace Scale {
	interface Basic extends Entity {
		[ScaleLabels.ScaleType]: string | null
		[ScaleLabels.Active]: boolean
	}
	namespace Form {
		interface Generic {
			[ScaleLabels.ScaleName]: string | null
			[ScaleLabels.ScaleType]: string | null
			[ScaleLabels.OrderingQuestion]: string | null
			[ScaleLabels.AskCustomer]: boolean
			[ScaleLabels.Active]: boolean
		}
		interface Add extends Generic {}
		interface Edit extends Generic {}
	}

	namespace Request {
		interface Generic {
			[ScaleLabels.ScaleName]: string | null
			[ScaleLabels.ScaleType]: string | null
			[ScaleLabels.OrderingQuestion]: string | null
			[ScaleLabels.AskCustomer]: boolean
			[ScaleLabels.Active]: boolean
		}
		interface Add extends Generic {}
		interface Edit extends Generic {}
	}

	interface Detailed extends Entity {
		[ScaleLabels.ScaleType]: string | null
		[ScaleLabels.OrderingQuestion]: string | null
		[ScaleLabels.AskCustomer]: boolean
		[ScaleLabels.Active]: boolean
	}

	namespace Price {
		interface Basic extends Entity {
			[ScalePriceLabels.LowValue]: BasicString
			[ScalePriceLabels.HighValue]: BasicString
			[ScalePriceLabels.Unit]: BasicString
			[ScalePriceLabels.Default]: boolean
		}

		interface ItemPriceErrorList {
			[ItemPriceErrorLabels.Id]: number
			[ItemPriceErrorLabels.ScaleId]: number
			[ItemPriceErrorLabels.ItemId]: number
			[ItemPriceErrorLabels.ItemName]: BasicString
		}

		namespace Form {
			interface Generic {
				[ScalePriceLabels.ScalePriceName]: BasicString
				[ScalePriceLabels.LowValue]: BasicString
				[ScalePriceLabels.HighValue]: BasicString
				[ScalePriceLabels.Unit]: BasicString
				[ScalePriceLabels.Default]: boolean
			}
		}

		namespace Request {
			interface Generic {
				[ScalePriceLabels.ScalePriceName]: BasicString
				[ScalePriceLabels.LowValue]: BasicString
				[ScalePriceLabels.HighValue]: BasicString
				[ScalePriceLabels.Unit]: BasicString
				[ScalePriceLabels.Default]: boolean
			}
		}
	}

	namespace Filter {
		interface Config {
			[ScaleSearchResultFields.id]: ConfigItem<ScaleSearchResultFields>
		}
	}
}
